import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListJenjangPrestasi = async () => {
  const response = await api.get("/master/jenjang-prestasi/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterJenjangPrestasiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenjangPrestasi"],
    queryFn: getListJenjangPrestasi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
